import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common-service';
import { FormGroup, NgForm, Validators,FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { map } from 'rxjs/operators';
import { SafeHtml } from '@angular/platform-browser';
import { SanitizationService } from '../sanitization.service';
import { WebSocketService } from '../websocket.service';

interface group { 
  label: string; 
  value: string; 
} 
@Component({
  selector: 'app-knowledge-hub',
  templateUrl: './knowledge-hub.component.html',
  styleUrls: ['./knowledge-hub.component.scss']
})
  

export class KnowledgeHubComponent implements OnInit{
  collections:any
  collectionForm: FormGroup=new FormGroup({
    collectionname: new FormControl(''),
    selectedCollectiontype: new FormControl(''),
    title: new FormControl(''),
    BaseContent: new FormControl(''),
    Summary: new FormControl(''),
    selectedTag: new FormControl([]),
    DefaultPrompt:new FormControl(''),
    toggle:new FormControl(true),
    enable_similarity_search: new FormControl(false)
  });
  collectionname:any='';
  title:any=''
  Parent :string="Demo-PrimeOS"
  showuploadmodal = false
  showaddcollection = false
  headers = new HttpHeaders()
  private httpClient: HttpClient;
  collection_to_upload_doc:any
  files: File[] = [];
  uploadloader=false
  collectionType:any
  selectedCollectiontype:any
  loadertosynccollection = false
  collectionLoaders: { [key: string]: boolean } = {};
  tags:any[]=[];
  BaseContent:any;
  submitted=false;
  selectedPromptValue:any;
  groupedType:group[] = [
    {
        label: 'Public',
        value: '1'
    },
    {
        label: 'Private',
        value: '2'
    }
  ];
  selectedType?:group; // Variable to hold the selected city
  collectionUser: any;
  ParentUser: any;
  selectedTag: []=[];
  Summary: any;
  responseData: any;
  DefaultPrompt: any;
  DefaultPrompts!: any[];
  prompt_code: any;
  isloading: boolean=false;
  defaultPromptCode: any;
  defaultpromptname!: string;
  defaultPromptValue: any;
  isGenerating: boolean=false
  isResultsAvailable: boolean=false;
  showprompt=false;
  file: any;
  modalloader=true;
  editForm: FormGroup;
  selectedfilecontent!: string;
  role: string | null;
  constructor(private api:CommonService,private router:Router,private fb:FormBuilder,
    handler: HttpBackend,private http: HttpClient,private messageService: MessageService,public sanitizeService:SanitizationService,public webSocketService:WebSocketService
    ){
      this.role = localStorage.getItem('role')
      this.httpClient = new HttpClient(handler);
      this.editForm = this.fb.group({
        content: ['']
      });
    }
 
  ngOnInit(): void {
    this.api.getMethod('get-collections/v2').subscribe((data:any)=>{
      this.collections = data
    })
    let payload = {}
    this.api.postMethod('get-collection-types',payload).subscribe((data:any)=>{
      this.collectionType = data
      this.selectedCollectiontype = data[0].name
    })
    this.getParentUser();
    this.initForm();
    this.fetchDefaultPrompt()
   }
   initForm(){
    this.collectionForm=this.fb.group({
      collectionname:['',[Validators.required,Validators.minLength(3),Validators.maxLength(40)]],
      selectedCollectiontype:['',Validators.required,],
      title:['',[Validators.required,Validators.minLength(3),Validators.maxLength(40)]],
      BaseContent:['',Validators.required],
      Summary:['',[Validators.required]],
      selectedTag:[[],Validators.required],
      DefaultPrompt:['',Validators.required],
      toggle:[true],
      enable_similarity_search:[false]
    })
  }
  get f()
  {
      return this.collectionForm.controls;
  }
  
  getParentUser(){
    let payload={}
    this.api.postMethod('get-user-collections',payload).subscribe((data:any)=>{
      this.collectionUser=data.collections
      this.ParentUser=data.collections[0].collection_name
    })
  }
  createcollection(collectionForm:FormGroup){
    this.submitted=true;
    if(this.collectionForm.valid){
    let payload = {
      name:this.collectionForm.value.collectionname,
      status: this.collectionForm.value.toggle,
      type: this.collectionForm.value.selectedCollectiontype,
      title: this.collectionForm.value.title,
      base_content:this.collectionForm.value.BaseContent,
      summary: this.collectionForm.value.Summary,
      tags: this.collectionForm.value.selectedTag,
      default_prompt: this.collectionForm.value.DefaultPrompt,
      enable_similarity_search:this.collectionForm.value.enable_similarity_search
    }
    this.api.postMethod('api/v1/save-collection',payload).subscribe({
      next:(data)=>{
        this.showaddcollection = false
        this.onDialogHideaddcollection()
        this.messageService.add({ severity: 'success', detail: data.message });
        this.submitted=false;
      this.ngOnInit()
      },
      error:(error) => {
        console.error('API Error:', error);
        this.messageService.add({ severity: 'error', detail: error.error.detail});
      }
    });
  }
  else{return;}
}

  showAddCollectionModal(){
    this.showaddcollection = true
  }

  onDialogHideaddcollection(){
    this.collectionname = ''
  }

  onDialogHideupload(){
    this.files = []
  }

  fetchdocs(name:any,collectionId:any){
    if(this.collectionLoaders[name]==true ){
    return;
    }else{this.router.navigate(['collection',name]);
      localStorage.setItem('collectionId',collectionId);
    }
  }

  uploadDoc(event: Event,collection_name:any){
    event.stopPropagation();
    this.showuploadmodal = true
    this.collection_to_upload_doc = collection_name
  }
  getfiletype(name:any){
    return  name.split('.').pop();
  }
  handleFileSelection(selectedFiles:File[]){
    this.files = [...this.files, ...selectedFiles];
  }

  handleFileDelete(file:any){
    const filesArray = Array.from(this.files);

  // Find the index of the file in the array
    const index = filesArray.findIndex(f => f === file);
    if (index !== -1) {
      filesArray.splice(index, 1);
      this.files = filesArray
    }
  }

  handleFileUpload(){
    const token = localStorage.getItem('token');
    if (!token || !this.files.length || !this.collection_to_upload_doc) {
      this.messageService.add({ severity: 'warn', summary: 'Invalid Data', detail: 'Please make sure to select files and provide a valid collection name.' });
      return;
    }

    this.uploadloader = true;

    this.api.uploadFiles(this.collection_to_upload_doc, this.files, token).subscribe({
      next: (response: any) => {
        this.showuploadmodal = false;
        this.uploadloader = false;

        response.forEach((file: any) => {
          const fileName = file.name;
          
          if (file.isDuplicateFile) {
            this.messageService.add({ 
              severity: 'warn', 
              summary: 'Duplicate File', 
              detail: `${fileName} is a duplicate file and was not uploaded.` 
            });
          } else if (file.isFileUploadedOnS3) {
            this.messageService.add({ 
              severity: 'success', 
              summary: 'File Uploaded', 
              detail: `${fileName} uploaded successfully.` 
            });
          } else {
            this.messageService.add({ 
              severity: 'error', 
              summary: 'Upload Failed', 
              detail: `${fileName} could not be uploaded to S3.` 
            });
          }
        });
      },
      error: (error:any) => {
        console.error('upload-collection-files', error);
        this.messageService.add({ severity: 'error', detail: error.error.detail });
        this.uploadloader = false;
      }
    });
  }
  
  summaryGeneratewithAI(){
    let payload={
      template_code: "smry",
      content:this.collectionForm.value.BaseContent
    }
  this.isGenerating=true;
  this.isResultsAvailable=false;
    this.api.postMethod('api/v1/generate_content_meta',payload).subscribe({
      next:(response:any) => {
        this.collectionForm.patchValue({Summary:response.data})
        this.isGenerating=false;
        this.isResultsAvailable=true;
      },
      error:(error)=>{this.isGenerating=false}}) 
    
  }
  tagGeneratewithAI(){
    let payload={
      template_code: "tag",
      content:this.collectionForm.value.BaseContent
    }
    this.isloading=true;
    this.api.postMethod('api/v1/generate_content_meta',payload).subscribe({
      next:(response:any) => {
        this.responseData=response;
        this.tags=this.responseData.data.split(',').map((item:any) => item.trim())
        this.isloading=false;
      },
      error:(error)=>{this.isloading=false}}
    )
  }
  fetchDefaultPrompt(){
    this.api.getMethod('api/v1/list_templates?template_type=prompt').subscribe((data:any)=>{
      this.DefaultPrompts = data.data;
      const index = this.DefaultPrompts.findIndex(item => item.template_code =='00');

// If an object with template_code 00 is found, move it to the beginning of the array
if (index != -1) {
  const defaultTemplate = this.DefaultPrompts.splice(index, 1)[0];
  this.DefaultPrompts.unshift(defaultTemplate);
}
      this.defaultPromptValue = this.DefaultPrompts[0].template_code;
       this.defaultpromptname = this.DefaultPrompts[0].template_name; 
      this.selectedPrompt(this.selectedPromptValue)
    })
  }
  selectedPrompt(e:any){    
   this.prompt_code=e?e.template_code:this.defaultPromptValue
   this.api.getMethod('api/v1/get_template?template_code='+this.prompt_code).subscribe((data:any)=>{
    let templateText = data.data.template_text;
    templateText = templateText.replace(/\\n/g, '\n');
    templateText = templateText.replace(/ {2,}/g, (match:string) => ' '.repeat(match.length));
    this.collectionForm.get('DefaultPrompt')?.patchValue(templateText)
  })

  }
  sanitizeMessage(message: string): SafeHtml {
    return this.sanitizeService.sanitizeMessage(message);
   }
  editprompt(event:Event,file:any){
    event.stopPropagation()
    this.file = file; 
    this.showprompt = true;
    this.selectedfilecontent = '';

    this.api.getMethod(`view-prompt?collection_name=${file.collectionName}&collection_id=${file.collection_id}`).subscribe((data: any) => {
        this.modalloader = false;
     this.selectedfilecontent = data;
     this.editForm.patchValue({
        content: data.data.prompt
      });
     })
  }

  saveChanges() {
    const updatedContent = this.editForm.value.content;
    let payload = {
      "collection_name": this.file.collectionName,
      "prompt": updatedContent,
      "collection_id": this.file.collection_id
  }
      this. modalloader=true
    this.api.postMethod('update-prompt', payload).subscribe( {
      next: (response: any) => {
        this.editForm.get('content')?.patchValue(updatedContent)
        this.showprompt=false
        this.modalloader=false
        this.onHidedefaultPrompt();
        this.messageService.add({ severity: 'success', detail: response.message});
        
    },
    error: (error: any) => {
        console.error('Error updating document', error);
        this.messageService.add({ severity: 'error', detail: error.error.detail});
        this.showprompt=false
        this.modalloader=false
    }
  })
    ;
  }
  closePrompt(){
    this.showprompt=false
  }
  onHidedefaultPrompt(){
    this.selectedfilecontent = ''
  }
}


